// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const getDrills = (queryParameters, contextConfiguration) => {
	const url = '/drills?video_id=_NOT_&fields=*'; //(process.env.VIDEO_ONLY != null )? '/drills?video_id=_NOT_&fields=*' : '/drills?fields=*';
	//let url = '/drills?video_id=_NOT_&fields=*';// limit=10&
//	let url = '/drills?fields=*';// limit=10&

	if (queryParameters != null && queryParameters.length > 0) {
		// url += '?';

		queryParameters.forEach(({ queryParameter, value }, index) => {
			// if (index > 0)
			// 	url += '&';

			url += `&${encodeURI(queryParameter)}=${encodeURI(value)}`;
		});
	}

	return axios.get(
		url,
		{
			...commonConfiguration,
			...contextConfiguration,
		}
	).catch(onRequestError);
};

export default getDrills;
